import { DEAD_ADDRESS, TRANSFER_TOPIC, VITALIK } from "../../integration.js";
import { CORE_PINNED_BLOCK_HASHES, CORE_PINNED_BLOCK_HEIGHTS, CORE_PINNED_TRANSACTION_HASHES } from "../pinned.js";
import { ERC20_BALANCE_OF_REFERENCE_CALLDATA } from "../fixture-inputs.js";
// LINK on Plasma — registered in Spectrum's `tokens` table (decimals=18).
const PLASMA_TOKEN = "0x76a443768a5e3b8d1aed0105fc250877841deb40";
export const PLASMA_TEST_CONFIG = {
    balance: { address: VITALIK },
    blockQuery: {
        block: CORE_PINNED_BLOCK_HEIGHTS.plasma,
        fixture: "getBlockByNumberPlasma",
    },
    balanceQuery: {
        address: VITALIK,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.plasma,
        fixture: "getBalancePlasma",
    },
    tokenBalanceQuery: {
        address: VITALIK,
        token: PLASMA_TOKEN,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.plasma,
        fixture: "getTokenBalancePlasma",
    },
    blockHashQuery: {
        hash: CORE_PINNED_BLOCK_HASHES.plasma,
        fixture: "getBlockByHashPlasma",
    },
    blockTransactionsQuery: {
        blockNumber: CORE_PINNED_BLOCK_HEIGHTS.plasma,
        fixture: "getBlockTransactionsPlasma",
    },
    transfersQuery: {
        address: VITALIK,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.plasma,
        fixture: "getTransfersPlasma",
    },
    simulateCallQuery: {
        to: PLASMA_TOKEN,
        data: ERC20_BALANCE_OF_REFERENCE_CALLDATA,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.plasma,
        fixture: "simulateCallPlasma",
    },
    traceTransactionQuery: {
        hash: CORE_PINNED_TRANSACTION_HASHES.plasma,
        fixture: "traceTransactionPlasma",
    },
    tokenMetadataQuery: {
        address: PLASMA_TOKEN,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.plasma,
        fixture: "getTokenMetadataPlasma",
    },
    tokenAllowanceQuery: {
        token: PLASMA_TOKEN,
        owner: VITALIK,
        spender: DEAD_ADDRESS,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.plasma,
        fixture: "getTokenAllowancePlasma",
    },
    portfolioQuery: {
        address: VITALIK,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.plasma,
    },
    receiptQuery: {
        hash: CORE_PINNED_TRANSACTION_HASHES.plasma,
        fixture: "getReceiptPlasma",
    },
    transactionByHashQuery: {
        hash: CORE_PINNED_TRANSACTION_HASHES.plasma,
        fixture: "getTransactionByHashPlasma",
    },
    estimateGasQuery: {
        to: VITALIK,
        fixture: "estimateGasPlasma",
    },
    codeQuery: {
        address: PLASMA_TOKEN,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.plasma,
        fixture: "getCodePlasma",
    },
    logsQuery: {
        // Plasma USDT0 — 50-block window for log density.
        address: PLASMA_TOKEN,
        topic0: TRANSFER_TOPIC,
        fromBlock: String(CORE_PINNED_BLOCK_HEIGHTS.plasma - 50),
        toBlock: String(CORE_PINNED_BLOCK_HEIGHTS.plasma),
        fixture: "getLogsPlasma",
    },
};
